// Legacy tasks-list URL — merged into the Suites page (2026-07 nav
// review): /suites shows tasks and suites together with membership
// visible from both directions. The task editor keeps its own URLs
// (/tasks/new, /tasks/:taskId) for deep links.
import { createFileRoute, redirect } from '@tanstack/react-router';

import { routes } from '../../lib/constants';

export const Route = createFileRoute('/tasks/')({
  beforeLoad: () => {
    throw redirect({ to: routes.SUITES, replace: true });
  },
  component: () => null,
});
